<template src="./Footer.html" />

<script>
export default {
  name: "Footer"
}
</script>

<style scoped src="./Footer.scss" lang="scss" />
